
(function(){
  var KEY='gkPrimeWishlist';
  function read(){
    try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return [];}
  }
  function write(items){
    localStorage.setItem(KEY,JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('gk:wishlist-updated',{detail:{items:items}}));
  }
  function has(handle){return read().some(function(x){return x.handle===handle;});}
  function payload(el){
    return {
      handle:el.dataset.productHandle||'',
      title:el.dataset.productTitle||'',
      url:el.dataset.productUrl||'',
      image:el.dataset.productImage||'',
      price:el.dataset.productPrice||'',
      compare:el.dataset.productCompare||''
    };
  }
  function setState(el,active){
    el.classList.toggle('is-active',active);
    el.setAttribute('aria-pressed',active?'true':'false');
    var label=active?'Remove from wishlist':'Add to wishlist';
    el.setAttribute('aria-label',label);
  }
  function sync(){
    var items=read();
    document.querySelectorAll('[data-gkf-wishlist-toggle]').forEach(function(el){
      setState(el,items.some(function(x){return x.handle===el.dataset.productHandle;}));
    });
    document.querySelectorAll('[data-gkf-wishlist-count]').forEach(function(el){el.textContent=items.length;});
  }
  document.addEventListener('click',function(e){
    var el=e.target.closest('[data-gkf-wishlist-toggle]');
    if(!el)return;
    e.preventDefault();e.stopPropagation();
    var item=payload(el); if(!item.handle)return;
    var items=read(), idx=items.findIndex(function(x){return x.handle===item.handle;});
    if(idx>=0){items.splice(idx,1);}else{items.unshift(item);}
    write(items);sync();
  });
  document.addEventListener('keydown',function(e){
    var el=e.target.closest('[data-gkf-wishlist-toggle]');
    if(!el || (e.key!=='Enter'&&e.key!==' '))return;
    e.preventDefault();el.click();
  });
  window.GKWishlist={read:read,write:write,has:has,sync:sync};
  document.addEventListener('DOMContentLoaded',sync);
  window.addEventListener('gk:wishlist-updated',sync);
})();